"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../Box"));

var _theme = _interopRequireDefault(require("../../theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cards = (0, _styledSystem.variant)({
  key: 'cards'
});
var overflowY = (0, _styledSystem.style)({
  prop: 'overflowY',
  cssProperty: 'overflowY'
});
var overflowX = (0, _styledSystem.style)({
  prop: 'overflowY',
  cssProperty: 'overflowY'
});
var Card = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Card",
  componentId: "sc-148lnzg-0"
})(_styledSystem.borders, _styledSystem.borderColor, _styledSystem.borderRadius, _styledSystem.boxShadow, _styledSystem.backgroundImage, _styledSystem.backgroundSize, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.opacity, cards, _styledSystem.overflow, overflowY, overflowX);
Card.propTypes = _objectSpread({}, _Box["default"].propTypes, {}, _styledSystem.maxHeight.propTypes, {}, _styledSystem.boxShadow.propTypes, {}, _styledSystem.borderRadius.propTypes, {}, _styledSystem.boxShadow.propTypes, {}, _styledSystem.backgroundImage.propTypes, {}, _styledSystem.backgroundSize.propTypes, {}, _styledSystem.backgroundPosition.propTypes, {}, _styledSystem.backgroundRepeat.propTypes, {}, _styledSystem.opacity.propTypes, {}, _styledSystem.overflow.propTypes);
Card.defaultProps = {
  theme: _theme["default"]
};
/** @component */

var _default = (0, _styledComponents.withTheme)(Card);

exports["default"] = _default;